/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-layout-map.js to modify the generation of this file.
import DefaultLayout from '../layouts/DefaultLayout';
import ITBLayout from '../layouts/ITBLayout';

const layouts = new Map();
layouts.set('DefaultLayout', DefaultLayout);
layouts.set('ITBLayout', ITBLayout);

export default layouts;
